"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.coreInitiativesFilesByIdDeleteAsyncSlice = void 0;
const name_1 = require("./name.js");
const remove_1 = require("../remove.js");
const xuder_1 = require("@sonar-software/xuder");
const _api_1 = require("../../../../api/index.js");
exports.coreInitiativesFilesByIdDeleteAsyncSlice = (0, xuder_1.createDeleteAsyncSlice)({
    httpSagaOptions: {
        successCombinationActionCreators: [remove_1.coreInitiativesFilesRemoveSyncSlice.syncActionCreator]
    },
    name: name_1.CoreInitiativesFilesByIdName,
    receive: false,
    request: true,
    requestHandler: _api_1.deleteInitiativeFile
});
//# sourceMappingURL=delete.js.map